import { Container } from 'reactstrap';
import styles from './styles.module.scss';
import clsx from "classnames";
import PropTypes from "prop-types";
import BreadCrumb from "@/components/Shared/BreadCrumb";
import Button from "@/components/Button";
import OverlayDots from "/public/site-assets/svg/overlay-dots.svg"
import { motion } from 'framer-motion';
import React, {useRef, useState, useEffect, useCallback} from 'react';
import {init, track} from "fbq";

export default function JobBanner({
    className,
    global,
    pathPrefix,
    breadcrumb_title,
    return_button_cta_link,
    return_button_cta_title,
    heading,
    post,
    cta_title_1,
    cta_link_1,
    job_sector_parent,
    job_sector,
    job_type,
    job_salary_daily
}) {
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isScrollingUp, setIsScrollingUp] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(0);

    useEffect(() => {
        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1 // Adjust threshold as needed, make it smaller for more sensitive detection
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(entry.target);
                }
            });
        }, options);

        observer.observe(sectionRef.current);

        // Cleanup function
        return () => {
            observer.disconnect();
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            const mobileDevice = window.innerWidth <= 991; // Adjust threshold for mobile devices
            // setIsVisible(!mobileDevice); // Hide motion on mobile devices
        };

        handleResize(); // Call initially
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.pageYOffset;
            setIsScrollingUp(prevScrollPos > currentScrollPos);
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [prevScrollPos]);

    // Convert published_at string to a Date object
    const publishedDate = new Date(post.published_at);

    // Format the date as '27th February'
    const formattedDate = `${publishedDate.getDate()}th ${getMonthName(publishedDate.getMonth())}`;

    const [headerHeight, setHeaderHeight] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            const headerElement = document.getElementById('header');
            if (headerElement) {
                setHeaderHeight(headerElement.getBoundingClientRect().height);
            }
        };

        // Initial call
        handleResize();

        // Event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup function
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Function to trigger Facebook Pixel script
    const handleButtonClick = useCallback(() => {
        init('574554866614571');
        track('AddToCart', {
            content_ids: [`0743ba8e-a6e0-4c4e-93ea-72163b12a2b4_${post.external_reference}`],
            content_type: 'product',
            value: 0.01,
            currency: 'EUR'
        })
    }, [post.external_reference]);

    return (
        <>
            <section ref={sectionRef} className={`${clsx(className, styles.root)}`} style={{ marginTop: `${headerHeight}px` }}>
                <Container className='position-relative'>
                    <div className='d-none d-lg-block'>
                        <BreadCrumb
                            title={breadcrumb_title}
                        />
                    </div>
                    {return_button_cta_link && (
                        <a href={`${return_button_cta_link}`} className='return'>{return_button_cta_title}</a>
                    )}
                    {heading && (
                        <motion.div initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 0.5 }}>
                            <h1 className='heading mb-3'>{heading}</h1>
                        </motion.div>
                    )}
                    {post.published_at && (
                        <div className='job-posted-date mb-3'>Posted {formattedDate}</div>
                    )}
                    <div className='d-flex flex-wrap gap-4 job-information-wrapper'>
                        {/* {post?.job_sector && (
                            <div className='job-information job-tags'><span className='job-tag'>SEN</span></div>
                        )} */}
                        {job_sector?.length >= 1 && (
                            <div className={`job-information job-tags `}>{job_sector?.map((post, index) => <span key={index} className={post.name.toLowerCase().replace(/\s+/g, '-')}>
                                {post.name}
                            </span>)}</div>
                        )}
                        {/* {job_sector?.length >= 1 && (
                            <div className='job-information job-tags'><span className='job-tag'>SEN</span></div>
                        )} */}
                        {post?.location && (
                            <div className='job-information job-location'>{post.location}</div>
                        )}
                        {job_type.length >= 1 && (
                            <div className='job-information job-type'>{job_type.map((post, index) => <span key={index}>{post.name}</span>)}</div>
                        )}
                        {/* {Array.isArray(job_salary_daily) && (
                            <div className='job-information job-pay'>{job_salary_daily.map((post, index) => <span key={index}>{post.name}</span>)}</div>
                        )} */}
                        {post?.salary_package && (
                            <div className='job-information job-location'>{post.salary_package}</div>
                        )}
                        {post?.external_reference && (
                            <div className='job-information job-reference'>{post.external_reference}</div>
                        )}
                    </div>
                    <motion.div className='overlay-dots top' initial={{ opacity: 0, y: 50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 1.5 }}><OverlayDots /></motion.div>
                    <motion.div className='overlay-dots bottom' initial={{ opacity: 0, y: -50 }} animate={isVisible ? { opacity: 1, y: 0 } : {}} transition={{ duration: 1.5 }}><OverlayDots /></motion.div>
                </Container>
                <div className={`apply-wrapper ${isScrollingUp ? 'active' : ''}`}>
                    <div className='inner-apply-wrapper '>
                        <Container>
                            {cta_title_1 && (
                                <Button
                                    text={`${cta_title_1}`}
                                    url={`${cta_link_1}`}
                                    className={`me-0 mb-3 primaryBtn black-shadow`}
                                    onClick={handleButtonClick}
                                />
                            )}
                        </Container>
                    </div>
                </div>
            </section>
        </>
    )
}

const getMonthName = (monthIndex) => {
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[monthIndex];
};

JobBanner.defaultProps = {
    pathPrefix: "",
    className: "pt-5",
};

JobBanner.propTypes = {
    pathPrefix: PropTypes.string,
    className: PropTypes.string,
};
